import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA4 from 'react-ga4';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Initialize Google Analytics 4 with your Measurement ID (G-XXXXXX)
ReactGA4.initialize('G-FY1JPK6SLK'); // Replace with your actual Measurement ID


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
